<div fxLayout="row" [ngClass]="fuseConfig.layout.navbar.primaryBackground" class="center">
    <fuse-navigation layout="horizontal"></fuse-navigation>
</div>